// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Select-module__root--KcD4h:not(li) {
  position: relative;
  display: inline-flex;
  height: 42px;
  color: #555;
  font-size: 0.875rem; /* 14px */
  font-weight: 400;
}

.Select-module__root--KcD4h:not(li)::after {
  position: absolute;
  top: 100%;
  right: 0;
  left: 0;
  height: 4px;
  content: '';
}

.Select-module__box--LTGr8 {
  box-sizing: border-box;
  display: inline-flex;
  width: 100%;
  height: 100%;
  align-items: center;
  gap: 8px;
  padding-inline: 12px;
  border: 1px solid #cbc5bc;
  border-radius: 4px;
  background-color: #fcfaf7;
  white-space: nowrap;
  cursor: pointer;
}

.Select-module__box--LTGr8::after {
  width: 6px;
  height: 6px;
  border-right: 1px solid currentcolor;
  border-bottom: 1px solid currentcolor;
  content: '';
  transform: translateY(-2px) rotate(45deg);
}

.Select-module__size-small--vFEi7 {
  height: 34px;
  font-size: 0.8125rem; /* 13px */
  line-height: 1.2727;
}

.Select-module__size-small--vFEi7 .Select-module__box--LTGr8 {
  padding-inline: 11px;
  height: 34px;
}

.Select-module__size-medium--DwlZr {
  height: 42px;
  font-size: 0.875rem; /* 14px */
}

.Select-module__size-medium--DwlZr .Select-module__box--LTGr8 {
  padding-inline: 12px;
}

.Select-module__container--nrIWZ {
  position: absolute;
  z-index: 10;
  top: calc(100% + 4px);
  left: 0;
  display: none;
  min-width: 100%;
  overflow: hidden;
  border: 1px solid #cbc5bc;
  border-radius: 4px;
  background-color: #fcfaf7;
}

.Select-module__root--KcD4h:not(li):hover .Select-module__container--nrIWZ,
.Select-module__root--KcD4h:not(li):focus-within .Select-module__container--nrIWZ {
  display: block;
}

.Select-module__container--nrIWZ ul {
  padding: 4px;
  margin: 0;
  list-style: none;
}

.Select-module__container--nrIWZ li {
  box-sizing: border-box;
  display: flex;
  min-height: 30px;
  align-items: center;
  padding-inline: 8px;
  border-radius: 3px;
  white-space: nowrap;
  cursor: pointer;
}

.Select-module__container--nrIWZ li:hover,
.Select-module__container--nrIWZ li.Select-module__is-active--WQgyX {
  background-color: #f1e9de;
  color: #1a1a1a;
}
`, "",{"version":3,"sources":["webpack://./../../packages/design-system/src/components/Select/Select.module.css"],"names":[],"mappings":"AAAA;EACE,kBAAkB;EAClB,oBAAoB;EACpB,YAAY;EACZ,WAAW;EACX,mBAAmB,EAAE,SAAS;EAC9B,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,QAAQ;EACR,OAAO;EACP,WAAW;EACX,WAAW;AACb;;AAEA;EACE,sBAAsB;EACtB,oBAAoB;EACpB,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,QAAQ;EACR,oBAAoB;EACpB,yBAAyB;EACzB,kBAAkB;EAClB,yBAAyB;EACzB,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,UAAU;EACV,WAAW;EACX,oCAAoC;EACpC,qCAAqC;EACrC,WAAW;EACX,yCAAyC;AAC3C;;AAEA;EACE,YAAY;EACZ,oBAAoB,EAAE,SAAS;EAC/B,mBAAmB;AACrB;;AAEA;EACE,oBAAoB;EACpB,YAAY;AACd;;AAEA;EACE,YAAY;EACZ,mBAAmB,EAAE,SAAS;AAChC;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,qBAAqB;EACrB,OAAO;EACP,aAAa;EACb,eAAe;EACf,gBAAgB;EAChB,yBAAyB;EACzB,kBAAkB;EAClB,yBAAyB;AAC3B;;AAEA;;EAEE,cAAc;AAChB;;AAEA;EACE,YAAY;EACZ,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,sBAAsB;EACtB,aAAa;EACb,gBAAgB;EAChB,mBAAmB;EACnB,mBAAmB;EACnB,kBAAkB;EAClB,mBAAmB;EACnB,eAAe;AACjB;;AAEA;;EAEE,yBAAyB;EACzB,cAAc;AAChB","sourcesContent":[".root:not(li) {\n  position: relative;\n  display: inline-flex;\n  height: 42px;\n  color: #555;\n  font-size: 0.875rem; /* 14px */\n  font-weight: 400;\n}\n\n.root:not(li)::after {\n  position: absolute;\n  top: 100%;\n  right: 0;\n  left: 0;\n  height: 4px;\n  content: '';\n}\n\n.box {\n  box-sizing: border-box;\n  display: inline-flex;\n  width: 100%;\n  height: 100%;\n  align-items: center;\n  gap: 8px;\n  padding-inline: 12px;\n  border: 1px solid #cbc5bc;\n  border-radius: 4px;\n  background-color: #fcfaf7;\n  white-space: nowrap;\n  cursor: pointer;\n}\n\n.box::after {\n  width: 6px;\n  height: 6px;\n  border-right: 1px solid currentcolor;\n  border-bottom: 1px solid currentcolor;\n  content: '';\n  transform: translateY(-2px) rotate(45deg);\n}\n\n.size-small {\n  height: 34px;\n  font-size: 0.8125rem; /* 13px */\n  line-height: 1.2727;\n}\n\n.size-small .box {\n  padding-inline: 11px;\n  height: 34px;\n}\n\n.size-medium {\n  height: 42px;\n  font-size: 0.875rem; /* 14px */\n}\n\n.size-medium .box {\n  padding-inline: 12px;\n}\n\n.container {\n  position: absolute;\n  z-index: 10;\n  top: calc(100% + 4px);\n  left: 0;\n  display: none;\n  min-width: 100%;\n  overflow: hidden;\n  border: 1px solid #cbc5bc;\n  border-radius: 4px;\n  background-color: #fcfaf7;\n}\n\n.root:not(li):hover .container,\n.root:not(li):focus-within .container {\n  display: block;\n}\n\n.container ul {\n  padding: 4px;\n  margin: 0;\n  list-style: none;\n}\n\n.container li {\n  box-sizing: border-box;\n  display: flex;\n  min-height: 30px;\n  align-items: center;\n  padding-inline: 8px;\n  border-radius: 3px;\n  white-space: nowrap;\n  cursor: pointer;\n}\n\n.container li:hover,\n.container li.is-active {\n  background-color: #f1e9de;\n  color: #1a1a1a;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"root": `Select-module__root--KcD4h`,
	"box": `Select-module__box--LTGr8`,
	"size-small": `Select-module__size-small--vFEi7`,
	"size-medium": `Select-module__size-medium--DwlZr`,
	"container": `Select-module__container--nrIWZ`,
	"is-active": `Select-module__is-active--WQgyX`
};
export default ___CSS_LOADER_EXPORT___;
